<template>
  <div id="app">
    <app-header></app-header>
    <router-view v-if="$store.state.seqPonto !== 0" />
    <SeletorPonto v-else-if="show" v-on:selected="startApp" />
  </div>
</template>

<script>
import Header from "./components/Header";
import conversorModelo from "./router/modelos";
import conversorModeloTempo from "./utils/modelosTempo";
import api from "./services/api";
import SeletorPonto from "./components/SeletorPonto";
import axios from "axios";

import fakeModel from "./store/fakeModel.js";

export default {
  components: {
    "app-header": Header,
    SeletorPonto: SeletorPonto
  },
  data: () => ({
    modeloAtual: {
      tipo: 0,
      info: "",
      timer: 0,
      maquinas: [],
      tempo: 0,
      indice: -1
    },
    modelos: [],
    tempo: 0,
    show: false
  }),
  async created() {
    if (this.$store.state.fake) {
      this.show = false;
      this.$store.commit("getContext", {
        empresa: "Directa",
        usuario: "Admin",
        password: "Senha",
        enderecoAPI: ""
      });
      this.startApp();
    } else if (process.env.NODE_ENV === "production") {
      axios
        .get("GetCurrentContext")
        .then(response => {
          let context = response.data;
          let empresa = context.Empresa;
          let usuario = context.Usuario;
          let password = context.Password;
          let enderecoAPI = context.EnderecoAPI;
          this.$store.commit("getContext", {
            empresa,
            usuario,
            password,
            enderecoAPI
          });
          this.show = true;
        })
        .catch(() => {
          alert("Falha ao buscar contexto. Verifique associação de recursos!");
          //console.log(`Erro de busca de context - ${e}`);
        });
    } else {
      let empresa = "Directa";
      let usuario = "admin";
      let password = "931593e17083242fbe693f6e47cd3c39515b9b65";
      let enderecoAPI =
        "http://128.0.0.151/ProducaoFacadeAPI_MESDEVELOPER/Viewer/";
      this.$store.commit("getContext", {
        empresa,
        usuario,
        password,
        enderecoAPI
      });
      this.show = true;
    }
  },
  methods: {
    setModelo(modelo) {
      const indiceAtual = this.modeloAtual.indice;
      const nModelos = this.modelos.length;
      this.modeloAtual = {
        tipo: modelo.TIP_MODELO,
        info: modelo.DSC_MENSAGEM_VIEWER,
        timer: modelo.VLR_TEMPO_ATUALIZACAO,
        maquinas: modelo.PRD057_ASSOC_MODELO_PAR_MAQ,
        indice: (indiceAtual + 1) % nModelos
      };
    },
    setTempoIntervalo() {
      this.tempo = 0;

      if (conversorModelo(this.modeloAtual.tipo) === "info") {
        this.tempo = this.tempo + this.modeloAtual.timer;
      } else {
        const _tipo = conversorModeloTempo(this.modeloAtual.tipo);
        for (let i = 0; i < this.modeloAtual.maquinas.length; i++) {
          if (i % _tipo === 0) {
            this.tempo = this.tempo + this.modeloAtual.timer;
          }
        }
      }
      let timer = this.modeloAtual.timer;
      this.$store.commit("gravarTimer", { timer });
    },
    rodarModelos() {
      this.setTempoIntervalo();
      setTimeout(() => {
        const indiceAtual = this.modeloAtual.indice;
        const nModelos = this.modelos.length;

        this.setModelo(this.modelos[(indiceAtual + 1) % nModelos]);
        const { name: path } = this.$router.currentRoute;

        let pathname = "";
        if (path.includes("disponibilidade")) pathname = "disponibilidade";
        else if (path.includes("qualidade")) pathname = "qualidade";
        else pathname = "oee";

        let proxRota = pathname + conversorModelo(this.modeloAtual.tipo);
        if (this.$router.currentRoute.path !== proxRota) {
          if (proxRota.includes("info")) {
            const info = this.modeloAtual.info;
            this.$store.commit("gravarInfo", { info });
          }
          // Se a rota proxima for igual a atual não precisa redirecionar
          this.$router.push({ name: proxRota });
        }
        this.rodarModelos();
      }, this.tempo * 1000);
    },
    async startApp(seqPonto) {
      if (this.$store.state.seqPonto !== 0) {
        return;
      }

      let modelos = [];
      if (seqPonto) {
        const dadosPonto = await api().get(
          `ObterDadosPontoVisualizacao/${seqPonto}`
        );
        modelos = dadosPonto.data.COR042_MODELO_VIEWER;
      } else {
        modelos = fakeModel;
      }

      const primeiroModelo = modelos[0];
      this.modelos = modelos;
      this.setModelo(primeiroModelo);
      let proxRota = "";

      if (!this.$store.state.fake) this.rodarModelos();
      const { name: path } = this.$router.currentRoute;

      let pathname = "";
      if (path.includes("disponibilidade")) pathname = "disponibilidade";
      else if (path.includes("qualidade")) pathname = "qualidade";
      else pathname = "oee";

      proxRota = pathname + conversorModelo(this.modeloAtual.tipo);
      this.$router.push({ name: proxRota });

      this.$store.commit("cadastraPonto", { seqPonto, modelos });
    }
  }
};
</script>

<style></style>
